function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js";
import React from "react";
import { connect, ReactReduxContext } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import ChatContext from "./Context";
import ApiClient from "./utils/api";
class Provider extends React.Component {
  constructor(props, context) {
    super(props, context);
    const {
      chatBotHost,
      dpdSession,
      client,
      salesforce,
      organizationId,
      eliteDeploymentId,
      platinumDeploymentId,
      eliteButtonId,
      platinumButtonId,
      googleApiKey
    } = this.props;
    this.config = {
      apikey: googleApiKey,
      chatbot: {
        host: chatBotHost,
        session: dpdSession,
        client
      },
      liveagent: {
        host: salesforce,
        session: null,
        client: null,
        organizationId,
        eliteDeploymentId,
        platinumDeploymentId,
        eliteButtonId,
        platinumButtonId
      }
    };
    this.apiClient = new ApiClient(this.config);
  }
  render() {
    return /*#__PURE__*/React.createElement(ChatContext.Provider, {
      value: {
        state: this.props.state,
        chatConfiguration: this.config,
        apiClient: this.apiClient
      }
    }, this.props.children);
  }
}
_defineProperty(Provider, "contextType", ReactReduxContext);
Provider.propTypes = {
  state: PropTypes.object,
  chatBotHost: PropTypes.string,
  dpdSession: PropTypes.object,
  client: PropTypes.string,
  salesforce: PropTypes.string,
  organizationId: PropTypes.string,
  eliteDeploymentId: PropTypes.string,
  platinumDeploymentId: PropTypes.string,
  eliteButtonId: PropTypes.string,
  platinumButtonId: PropTypes.string,
  googleApiKey: PropTypes.string,
  children: PropTypes.node
};
const mapStateToProps = (state, ownProps) => ({
  state: state[ownProps.prefix]
});
const ReduxifyProvider = compose(connect(mapStateToProps, null))(Provider);
ReduxifyProvider.defaultProps = {
  prefix: "chat"
};
export default ReduxifyProvider;